export default "__VITE_ASSET__afa561d8__"